import contracts from "../../api/contracts";

/** Formate une date en YYYY-MM-DD, qu'elle soit une string ou un objet Date. */
const formatDate = (date) => {
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    loading: false,
    allCustomerNumbers: [],
    editedItemExclusions: [],
    editedItem: {
      Id: null,
      name: "",
      startDate: new Date(),
      endDate: new Date(new Date().getFullYear() + 1, 0, 15),
      customerNumbers: [],
      active: false,
    },
    defaultItem: {
      Id: null,
      name: "",
      startDate: new Date(),
      endDate: new Date(new Date().getFullYear() + 1, 0, 15),
      customerNumbers: [],
      active: false,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setAllCustomerNumbers(state, customerNumbers) {
      state.allCustomerNumbers = customerNumbers;
    },
    setEditedItem(state, item) {
      const editedItem = {
        Id: item.id,
        name: item.name,
        startDate: item.startDate,
        endDate: item.endDate,
        customerNumbers: item.customerNumbers,
        active: item.active,
      };
      state.editedItem = editedItem;
    },
    setEditedItemExclusions(state, item) {
      state.editedItemExclusions = item;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setEditedEndDate(state, endDate) {
      state.editedItem.endDate = endDate;
    },
    setEditedStartDate(state, startDate) {
      state.editedItem.startDate = startDate;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return contracts.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    fetchAllCustomerNumbers({ commit }) {
      return contracts.getAllCustomerNumbers().then((response) => {
        commit("setAllCustomerNumbers", response.data);
        return response;
      });
    },
    getByCustomerId({ commit }, customerId) {
      return contracts.getByCustomerId(customerId).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    getExclusions({ commit }, customerId) {
      return contracts.getExclusions(customerId).then((response) => {
        commit("setEditedItemExclusions", response.data);
        return response;
      });
    },
    getExclusionsByContractId({ commit }, contractId) {
      return contracts
        .getExclusionsByContractId(contractId)
        .then((response) => {
          commit("setEditedItemExclusions", response.data);
          return response;
        });
    },
    putExclusions({ commit }, data) {
      return contracts.putExclusions(data).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }) {
      const data = {
        name: state.editedItem.name,
        startDate: formatDate(state.editedItem.startDate),
        endDate: formatDate(state.editedItem.endDate),
        customerNumbers: state.editedItem.customerNumbers,
        active: state.editedItem.active,
      };
      return contracts.store(data).then((response) => {
        dispatch("fetchAll");
        return response;
      });
    },
    updateEditedItem({ dispatch, state }) {
      const data = {
        name: state.editedItem.name,
        startDate: formatDate(state.editedItem.startDate),
        endDate: formatDate(state.editedItem.endDate),
        customerNumbers: state.editedItem.customerNumbers,
        active: state.editedItem.active,
      };
      return contracts.update(state.editedId, data).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    deleteItem({ dispatch }, id) {
      return contracts.delete(id).then((response) => {
        dispatch("fetchAll");
        return response;
      });
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
